import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { styled } from "@mui/material/styles";
import useStyles from "./styles";
import { AccordionProps as AccordionPropsV2 } from "./interface";
import Text from "@ds/components/Text";

export const AccordionV2 = ({ children, summary, width }: AccordionPropsV2) => {
  const classes = useStyles();

  return (
    <MuiAccordion disableGutters elevation={0} square className={classes.root} sx={{ width }}>
      <AccordionSummary expandIcon={<ArrowDropDownIcon className={classes.dropdownIcon} />}>
        <Text weight="700">{summary}</Text>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid #DEE3ED`,
  "&:before": {
    display: "none",
  },
  borderRadius: "5px",
  margin: theme.spacing(2, 0),
}));

export default Accordion;
